export default "__VITE_ASSET__DzMDp8bn__";